import React, { useEffect } from "react";
import {
  AffectedRptIcon,
  AgencyManagement,
  AnimalShelterIconReport,
  Awareness,
  ColdWaveDashboard,
  CommunityKitchen,
  CommunityKitchenIcon,
  ConfigurationManagement,
  ConsolidatedRptIcon,
  ContactManagement,
  DailyFloodIcons,
  DailyReportsIcon,
  DashboardIcon,
  DashboardIconNew,
  DevicesIcon,
  EventsIcon,
  Execution,
  ExecutionSop,
  FacilityManagement,
  FireDashboard,
  FloodDashboardIcon,
  FloodRelief,
  GisManagement,
  HeatWaveDashboard,
  Home,
  HumanLoss,
  IncidentDashboard,
  IncidentFacility,
  Instancelist,
  MapIcon,
  MasterResourceManagement,
  MisReportsIcon,
  MyTaskList,
  MyTasks,
  PartiallyAffectedRptIcon,
  PolicesIcon,
  RegionManagement,
  Relief,
  ReportsIcon,
  ReportStatusIcon,
  ResourceManagement,
  Resources,
  ResourcesIcons,
  RolesIcons,
  Soplisticons,
  SopManagement,
  StateFloodIcons,
  TaskManagement,
  TaskManagementIcon,
  TasksList,
  TasksSopIcons,
  UserRoleManagement,
  UserRoleManagementIcon,
  UsersIcon,
  UsersIcons,
} from "../Components/IconComponents";
import SvgIncidentFacility from "../Components/IconComponents/IncidentFacility";
import SvgIncidentDashboard from "../Components/IconComponents/IncidentDashboard";
import { Bot } from 'lucide-react'

const height = "1.2em";
const width = "1.2em";

const navLinks = [
  {
    to: "dist-dashboard",
    icon: <DashboardIconNew width={"1.5em"} height={"1.5em"} />,
    // label: "navlinklabels.dashboard",
    allowedPermissionIds: [64],
    label: "Dashboard",
    children: [
      {
        to: "dist-dashboard",
        icon: <FloodDashboardIcon width={width} height={height} />,
        label: "navlinklabels.flooddashboard",
        allowedPermissionIds: [56],
        children: [],
      },
      {
        to: "humanloss-dashboard",
        icon: <HumanLoss width={"2.2em"} height={"2.2em"} />,
        label: "Human Loss - Primary Information Dashboard",
        allowedPermissionIds: [57],
        children: [],
      },
      {
        to: "fire-dashboard",
        icon: <FireDashboard width={"1.2em"} height={"1.2em"} />,
        label: "Fire Incident Dashboard",
        allowedPermissionIds: [59],
        children: [],
      },
      {
        to: "heatwave-dashboard",
        icon: <HeatWaveDashboard width={width} height={height} />,
        label: "Heat Wave Dashboard",
        allowedPermissionIds: [60],
        children: [],
      },
      {
        to: "coldwave-dashboard",
        icon: <ColdWaveDashboard width={width} height={height} />,
        label: "Cold Wave Dashboard",
        allowedPermissionIds: [58],
        children: [],
      },
      {
        to: "dmsdashboard",
        icon: <IncidentFacility width={"1.5em"} height={"1.5em"} />,
        label: "navlinklabels.incidentdashboard",
        allowedPermissionIds: [67],
        children: [],
      },
      {
        to: "incidentdashboard",
        icon: <IncidentDashboard width={width} height={height} />,
        label: "Incident Dashboard",
        allowedPermissionIds: [68],
        children: [],
      },
    ],
  },
  {
    to: "reports",
    icon: <ReportsIcon width={"1.6em"} height={"1.6em"} />,
    label: "Report",
    allowedPermissionIds: [69],
    children: [
      {
        to: "affected-floodreport",
        icon: <FloodDashboardIcon width={width} height={height} />,
        label: "Flood Reports",
        allowedPermissionIds: [70],
        children: [
          {
            to: "../affected-floodreport",
            label: "navlinklabels.dailyreport",
            icon: <DailyFloodIcons width={width} height={height} />,
            children: [
              // {
              //   to: "../heatwave-dashboard",
              //   icon: "",
              //   label: "Heat Wave Dashboard",
              // },
              {
                to: "../affected-floodreport",
                icon: <DailyReportsIcon width={"1.5em"} height={"1.5em"} />,
                label: "Form 1 - Daily Report",
                children: [],
              },
              {
                to: "../partiallyaffected-floodreport",
                icon: (
                  <PartiallyAffectedRptIcon width={"1.7em"} height={"1.7em"} />
                ),
                label: "Partially Affected Report",
                children: [],
              },
              {
                to: "../dailyfloodreport",
                icon: <ConsolidatedRptIcon width={"1.7em"} height={"1.7em"} />,
                label: "Flood Report Consolidated",
                children: [],
              },
              {
                to: "../reporting-status",
                icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
                label: "Form 1 - Reporting Status",
                children: [],
              },
            ],
          },
          {
            to: "../affected-report",
            label: "State Flood Report",
            icon: <StateFloodIcons width={width} height={height} />,
            children: [
              {
                to: "",
                icon: <AffectedRptIcon width={width} height={height} />,
                label: "Affected Report",
                children: [],
              },
              {
                to: "../partiallyaffected-report",
                icon: (
                  <PartiallyAffectedRptIcon width={"1.7em"} height={"1.7em"} />
                ),
                label: "Partially Affected Report",
                children: [],
              },
              {
                to: "../statefloodreport",
                icon: <ConsolidatedRptIcon width={"1.5em"} height={"1.5em"} />,
                label: "Consolidated Report",
                children: [],
              },
              // {
              //   to: "../misstate-report",
              //   icon: "",
              //   label: "MIS State Flood Report",
              // },
              // {
              //   to: "../form9",
              //   icon: "",
              //   label: "Form 9",
              //   children: [],
              // },
            ],
          },
          {
            to: "../misdist-report",
            icon: <MisReportsIcon width={width} height={height} />,
            label: "MIS Flood Report",
            children: [],
          },
        ],
      },
      {
        to: "human-loss-report",
        icon: <HumanLoss width={width} height={height} />,
        label: "Human Loss Reports",
        allowedPermissionIds: [71],
        children: [
          {
            to: "../human-loss-report",
            icon: <DailyReportsIcon width={"3.0em"} height={"3.0em"} />,
            label: "Human Loss - Primary And Detailed Information Report",
            children: [],
          },
          {
            to: "../mis-human-loss-report",
            icon: <MisReportsIcon width={"1.5em"} height={"1.5em"} />,
            label: "Human Loss - MIS Report",
            children: [],
          },
        ],
      },
      {
        to: "fireincident-report",
        icon: <FireDashboard width={width} height={height} />,
        label: "Fire Reports",
        allowedPermissionIds: [72],
        children: [
          {
            to: "../fireincident-report",
            icon: <DailyReportsIcon width={"2.0em"} height={"2.0em"} />,
            label: "Fire Incident - Daily Report Form",
            children: [],
          },
          {
            to: "../mis-fire-report",
            icon: <MisReportsIcon width={width} height={height} />,
            label: "Fire - MIS Report",
            children: [],
          },
          {
            to: "../fire-community-kitchen-report",
            icon: <CommunityKitchen width={"2.0em"} height={"2.0em"} />,
            label: "Fire - Community kitchen Daily Report",
            children: [],
          },
          {
            to: "../fire-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Fire Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "heat-wave-report",
        icon: <HeatWaveDashboard width={width} height={height} />,
        label: "Heat Wave Reports",
        allowedPermissionIds: [73],
        children: [
          {
            to: "../heat-wave-report",
            icon: <DailyReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Heat Wave - Daily Report",
            children: [],
          },
          {
            to: "../heat-wave-misreport",
            icon: <MisReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Heat Wave - MIS Report",
            children: [],
          },
          {
            to: "../heat-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Heat Wave Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "dr-cold-wave",
        icon: <ColdWaveDashboard width={width} height={height} />,
        label: "Cold Wave Reports",
        allowedPermissionIds: [74],
        children: [
          {
            to: "../dr-cold-wave",
            icon: <DailyReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cold Wave - Daily Report",
            children: [],
          },
          {
            to: "../misdist-coldwave-report",
            icon: <MisReportsIcon width={"1.4em"} height={"1.4em"} />,
            label: "Cold Wave - MIS Report",
            children: [],
          },
          {
            to: "../cold-wave-reporting-status",
            icon: <ReportStatusIcon width={"1.7em"} height={"1.7em"} />,
            label: "Cold Wave Daily Report Status",
            children: [],
          },
        ],
      },
      {
        to: "community-kitchen",
        icon: <IncidentFacility width={"1.5em"} height={"1.5em"} />,
        label: "Incident Facilities Reports",
        allowedPermissionIds: [75],
        children: [
          {
            to: "../community-kitchen",
            icon: <CommunityKitchenIcon width={"1.5em"} height={"1.5em"} />,
            label: "navlinklabels.communitykitchen",
            allowedPermissionIds: [76],
            children: [],
          },
          {
            to: "../fl-camp",
            icon: <FloodRelief width={"1.7em"} height={"1.7em"} />,
            label: "navlinklabels.floodcamp",
            allowedPermissionIds: [77],
            children: [],
          },
          {
            to: "../animal-shelter",
            icon: <AnimalShelterIconReport width={"1.5em"} height={"1.5em"} />,
            label: "navlinklabels.animalshelter",
            allowedPermissionIds: [78],
            children: [],
          },
        ],
      },
    ],
  },
  {
    to: "my-tasks",
    icon: <MyTasks width={"1.6em"} height={"1.6em"} />,
    // label: "navlinklabels.mytask",
    label: "My Task",
    allowedPermissionIds: [79],
    children: [
      {
        to: "my-tasks",
        icon: <MyTaskList width={width} height={height} />,
        label: "navlinklabels.tasklist",
        allowedPermissionIds: [80],
        children: [],
      },
      {
        to: "view-usertask",
        icon: <TaskManagementIcon width={width} height={height} />,
        label: "navlinklabels.taskmgmnt",
        allowedPermissionIds: [40],
        children: [],
      },
    ],
  },
  {
    to: "masterdata-table",
    // icon: <ReportsIcon width={width} height={height} />,
    icon: <UsersIcon width={"1.6em"} height={"1.6em"} />,
    allowedPermissionIds: [1],
    // label: "navlinklabels.adminstrativeactivities",
    label: "Administrative Activities",
    children: [
      {
        to: "masterdata-table",
        icon: <ConfigurationManagement width={"1.6em"} height={"1.6em"} />,
        label: "navlinklabels.configmgmnt",
        allowedPermissionIds: [2],
        children: [],
      },
      {
        to: "../region-list",
        icon: <RegionManagement width={width} height={height} />,
        label: "navlinklabels.regionmgmnt",
        allowedPermissionIds: [6],
        children: [],
      },
      {
        to: "../agency-list",
        icon: <AgencyManagement width={width} height={height} />,
        label: "navlinklabels.agencymgmnt",
        children: [],
        allowedPermissionIds: [10],
      },
     {
  to: "../users",
  icon: <UserRoleManagementIcon width={width} height={height} />,
  label: "navlinklabels.userrolemgmnt",
  allowedPermissionIds: [37],
  children: [
    {
      to: "../users",
      icon: <UsersIcons width={"1.0em"} height={"1.0em"} />,
      label: "navlinklabels.users",
      allowedPermissionIds: [37],
      children: [],
    },
    {
      to: "roles",
      icon: <RolesIcons width={"1.0em"} height={"1.0em"} />,
      label: "navlinklabels.roles",
      allowedPermissionIds: [37],
      children: [],
    },
  ],
},

      {
        to: "../master-resource",
        icon: <MasterResourceManagement width={width} height={height} />,
        label: "navlinklabels.masterresource",
        allowedPermissionIds: [18],
        children: [],
      },
      {
        to: "../user-activity",
        icon: <UserRoleManagement width={"1.6em"} height={"1.6em"} />,
        label: "navlinklabels.useractivity",
        allowedPermissionIds: [38],
        children: [],
      },
    ],
  },
  {
    to: "planning",
    icon: <DevicesIcon width={"1.6em"} height={"1.6em"} />,
    // label: "navlinklabels.planning",
    label: "Planning",
    allowedPermissionIds: [26],
    children: [
      {
        to: "view-contact",
        icon: <ContactManagement width={width} height={height} />,
        label: "navlinklabels.contactmgmnt",
        allowedPermissionIds: [22],
        children: [],
      },
      {
        to: "../facility-mgmt",
        icon: <FacilityManagement width={width} height={height} />,
        label: "navlinklabels.facilitymgmnt",
        allowedPermissionIds: [34],
        children: [],
      },
      {
        to: "../resource-list",
        icon: <Resources width={width} height={height} />,
        label: "navlinklabels.resourcemgmnt",
        allowedPermissionIds: [35],
        children: [],
      },
      {
        to: "view-sop",
        icon: <SopManagement width={width} height={height} />,
        label: "navlinklabels.sopmgmnt",
        allowedPermissionIds: [36],
        children: [
          {
            to: "../view-sop",
            icon: <Soplisticons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.SOPlist",
            children: [],
          },
          {
            to: "../view-task",
            icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.task",
            children: [],
          },
          {
            to: "../create-sop",
            icon: <ResourcesIcons width={"1.0em"} height={"1.0em"} />,
            label: "navlinklabels.SOP",
            children: [],
          },
          {
            to: "../execute-sops",
            icon: <ExecutionSop width={width} height={height} />,
            label: "navlinklabels.execute-sops",
            children: [],
          },
          {
            to: "../Sop-instance-list",
            icon: <Instancelist width={width} height={height} />,
            label: "navlinklabels.sopinstancelist",
            children: [],
          },
        ],
      },
    ],
  },
  {
    to: "situation-awareness",
    icon: <Awareness width={"1.6em"} height={"1.6em"} />,
    // label: "navlinklabels.mytask",
    label: "Situational Awareness/GIS",
    allowedPermissionIds: [27],
    children: [
      {
        to: "situation-awareness",
        icon: <MapIcon width={width} height={height} />,
        label: "navlinklabels.mapview-gis",
        allowedPermissionIds: [28],
        children: [],
      },
      {
        to: "incident-management",
        icon: <SvgIncidentDashboard width={width} height={height} />,
        label: "navlinklabels.incident-managet",
        allowedPermissionIds: [29],
        children: [],
      },
    ],
  },
  {
    to: "resource-assign-list",
    icon: <Relief width={"1.6em"} height={"1.6em"} />,
    label: "Response & Relief",
    // allowedRoles: ["manage-users"],
    allowedPermissionIds: [31],
    children: [
      {
        to: "resource-assign-list",
        icon: <UsersIcons width={"1.0em"} height={"1.0em"} />,
        label: "navlinklabels.resourceallocationlist",
        allowedPermissionIds: [81],
        children: [],
      },
      {
        to: "deployment-resource",
        icon: <TasksSopIcons width={"1.0em"} height={"1.0em"} />,
        label: "navlinklabels.resourcedeploymentresource",
        allowedPermissionIds: [82],
        children: [],
      },
    ],
  }, 
  // {
  //   to: "Chatbot",
  //    icon: <Bot width={"1.6em"} height={"1.6em"} />,
  //   // label: "navlinklabels.mytask",
  //   label: "Chatbot",
  //   children: [

  //   ],
  // },


  // {
  //     to: "resource-assign-deploy",
  //     icon: <MyTasks width={"1.6em"} height={"1.6em"} />,
  //     // label: "navlinklabels.mytask",
  //     label: "Resource Allocation List",
  //     children: [
  //       {
  //         to: "resource-assign-deploy",
  //         icon: <MyTaskList width={width} height={height} />,
  //         label: "Resource Allocation List",
  //         children: [],
  //       },
  //       {
  //         to: "deployment-resource",
  //         icon: <TaskManagementIcon width={width} height={height} />,
  //         label: "Deployment Resource",
  //         children: [],
  //       },
  //     ],
  //   },

];
// return navLinks;
// };

export default navLinks;
